import { render } from "./relojtiempo_ingles.vue?vue&type=template&id=d9bff216&scoped=true"
import script from "./relojtiempo_ingles.vue?vue&type=script&lang=js"
export * from "./relojtiempo_ingles.vue?vue&type=script&lang=js"

import "./relojtiempo_ingles.vue?vue&type=style&index=0&id=d9bff216&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9bff216"]])

export default __exports__